import React from "react";

/**
 * Geometria: banda de temperatura (header + 5 KPIs) + barra de abas + tabela
 * da aba padrão ("Leads Quentes", 6 colunas) — mesmos radius/border/gap/padding
 * do restante da família de páginas de Insights (rounded-xl, border-purple-200,
 * gap-2, p-3).
 */
const RevenueIntelligenceSkeleton: React.FC = () => (
  <div className="w-full flex flex-col gap-2 animate-pulse">
    {/* Banda: SectionHeader + KPIs de temperatura */}
    <div className="bg-white rounded-xl border border-purple-200 p-3 shadow-xs flex flex-col gap-3">
      <div className="flex items-start justify-between border-b pb-2 border-purple-100">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-purple-200 rounded-xl shrink-0" />
          <div className="h-10 flex flex-col justify-between">
            <div className="h-3.5 w-44 bg-gray-300 rounded-sm" />
            <div className="h-2.5 w-56 bg-gray-200 rounded-sm" />
          </div>
        </div>
        <div className="h-8 w-24 bg-gray-100 rounded-lg" />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
        {[1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            className="relative bg-white rounded-xl border border-purple-200 p-3.5 shadow-xs flex flex-col justify-between min-h-[104px] overflow-hidden"
          >
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-purple-100" />
            <div className="flex items-start justify-between pt-0.5">
              <div className="flex flex-col gap-1">
                <div className="h-2.5 w-14 bg-gray-200 rounded-sm" />
                <div className="h-7 w-8 bg-gray-300 rounded-sm" />
              </div>
              <div className="w-9 h-9 rounded-lg bg-purple-50" />
            </div>
            <div className="h-1 w-full bg-gray-100 rounded-full mt-2" />
          </div>
        ))}
      </div>
    </div>

    {/* Barra de abas */}
    <div className="flex gap-2">
      {[1, 2, 3].map((i) => (
        <div key={i} className="h-8 w-40 bg-gray-100 rounded-lg" />
      ))}
    </div>

    {/* Card da aba ativa: tabela */}
    <div className="bg-white rounded-xl border border-purple-200 p-3 shadow-xs flex flex-col gap-2">
      <div className="flex items-start gap-3 border-b pb-2 border-purple-100 mb-1">
        <div className="w-10 h-10 bg-amber-100 rounded-xl shrink-0" />
        <div className="h-10 flex flex-col justify-between">
          <div className="h-3.5 w-32 bg-gray-300 rounded-sm" />
          <div className="h-2.5 w-24 bg-gray-200 rounded-sm" />
        </div>
      </div>
      <div className="rounded-xl border border-purple-200 overflow-hidden">
        <div className="grid grid-cols-6 gap-2 bg-purple-50/40 border-b border-purple-200 px-4 py-2.5">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="h-2.5 bg-gray-200 rounded-sm" />
          ))}
        </div>
        {[1, 2, 3, 4, 5, 6].map((row) => (
          <div
            key={row}
            className="grid grid-cols-6 gap-2 px-4 py-3 border-b border-purple-100 last:border-0"
          >
            {[1, 2, 3, 4, 5, 6].map((col) => (
              <div key={col} className="h-3 bg-gray-100 rounded-sm" />
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default RevenueIntelligenceSkeleton;
